// extracted by mini-css-extract-plugin
export var hidden = "_6r-1";
export var leftPanel = "_6r-2";
export var readonlyInspector = "_6r-3";
export var rightPanel = "_6r-0";